import { palette } from '../global/palette';
export const MuiDialogContentText = {
    MuiDialogContentText: {
        styleOverrides: {
            root: {
                color: palette.grey[800],
                '&:last-child': {
                    marginBottom: 0,
                },
            },
        },
        defaultProps: {
            variant: 'body2',
        },
    },
};
